import { $error } from '@settings/errorContext';
import { graphQLClient } from '@settings/services/graphQLClient';
import { GraphQLClient } from '@settings/services/graphQLClient/GraphQLClient';
import { loggerFactory } from '@settings/services/logger';
import { Logger } from '@settings/services/logger/Logger';

import {
  OrderProduct,
  _OrderProductLoaderProcessorInterface,
  _OrderProductLoaderResponse,
} from './interface';
import { OrderProductLoaderProcessorQuery } from './OrderProductLoaderProcessorQuery';

// Процессора загрузки товаров заказов
export class OrderProductLoaderProcessor implements _OrderProductLoaderProcessorInterface {
  private readonly client: GraphQLClient;

  private readonly logger: Logger;

  /**
   * Конструктор процессора
   */
  constructor(token: string) {
    this.client = graphQLClient(token);
    this.logger = loggerFactory().make('OrderProductLoaderProcessor');
  }

  /**
   * Проверка доступности процессора
   * @param type
   */
  IsAvailable(type: 'order' | 'preOrder'): boolean {
    return type === 'order';
  }

  /**
   * Загрузка товаров заказа
   * @param orderId
   */
  async Load(orderId: string): Promise<OrderProduct[]> {
    try {
      const resp = await this.client.Query<{ id: string }, _OrderProductLoaderResponse>(
        new OrderProductLoaderProcessorQuery(orderId),
        {}
      );

      this.logger.Debug(`Loaded order products data`, resp);
      if ((resp?.data || []).length === 0) {
        return [];
      }

      return resp.data;
    } catch (e) {
      this.logger.Error(`Error:`, e);
      $error.next(e);
    }
  }
}
